import { createFileRoute, Outlet } from "@tanstack/react-router";
import { m } from "@/lib/paraglide/messages.js";

// /staff/resellers and /staff/resellers/:resellerId share a crumb, so a reseller's page leads
// back to the list.
export const Route = createFileRoute("/staff/_authenticated/resellers")({
  staticData: { crumb: m.staff_nav_resellers },
  component: Outlet,
});
